function appendBannersInsideProductGrid(gridSize = null, viewportType = null) {
  if (Array.isArray(BANNERS_INSIDE_COLLECTION) && BANNERS_INSIDE_COLLECTION.length <= 0) return null;
  const CURRENTPAGE = window.location.search.includes("&page=") ? window.location.search.split("&page=")[1] : 1;
  const MIN_PRODUCT = PRODUCTS_PER_PAGE * (CURRENTPAGE - 1);
  const MAX_PRODUCT = PRODUCTS_PER_PAGE * CURRENTPAGE;

  function getHTMLStringToAppend(banner) {
    if (banner.type == 'product-card-banner') {
      return `
        <li data-position="${banner.position}"
            data-appended="addedDOMNode" data-id="${banner.id}"
            class="grid__item scroll-trigger product-card-banner"
        >
          ${typeof banner.link === 'object' && banner.link !== null && 'url' in banner.link && typeof banner.link.url === 'string' && banner.link.url.trim() !== '' ? `<a href="${banner.link.url}" alt="${banner.link.text}">` : '' }
            <img
              src="${banner.image_desktop}&amp;width=420"
              srcset="${banner.image_desktop}&amp;width=70 70w,
              ${banner.image_desktop}&amp;width=140 140w,
              ${banner.image_desktop}&amp;width=165 165w,
              ${banner.image_desktop}&amp;width=220 220w,
              ${banner.image_desktop}&amp;width=360 360w,
              ${banner.image_desktop}&amp;width=420 420w"
              width="420" height="420"
              class="motion-reduce media_product"
              sizes="(max-width: 1024px) 220px, (min-width: 1024px) 360px, (min-width:1400px) 420px"
            >
          ${typeof banner.link === 'object' && banner.link !== null && 'url' in banner.link && typeof banner.link.url === 'string' && banner.link.url.trim() !== '' ? `</a>` : '' }
        </li>
      `;
    } else if (banner.type === 'full-width-banner') {
      return `
        <li data-row="${banner.full_width_banner_row}"
            data-appended="addedDOMNode"
            data-full-width="fullWidth"
            data-id="${banner.id}"
            class="grid__item scroll-trigger full-width-banner custom-padding-right
            "
        >
          ${typeof banner.link === 'object' && banner.link !== null && 'url' in banner.link && typeof banner.link.url === 'string' && banner.link.url.trim() !== '' ? `<a href="${banner.link.url}" alt="${banner.link.text}">` : '' }
            <img
              src="${banner.image_desktop}&amp;width=1600"
              srcset="${banner.image_desktop}&amp;width=70 70w,
              ${banner.image_desktop}&amp;width=140 140w,
              ${banner.image_desktop}&amp;width=165 165w,
              ${banner.image_desktop}&amp;width=220 220w,
              ${banner.image_desktop}&amp;width=360 360w,
              ${banner.image_desktop}&amp;width=420 420w,
              ${banner.image_desktop}&amp;width=1600 1600w"
              width="1600" height="420"
              class="motion-reduce media_product small-hide"
              sizes="(max-width: 1024px) 220px, (min-width: 1024px) 1600px, (min-width:1400px) 1600px"
            >
            <img
              src="${banner.image_mobile}&amp;width=420"
              srcset="${banner.image_mobile}&amp;width=70 70w,
              ${banner.image_mobile}&amp;width=140 140w,
              ${banner.image_mobile}&amp;width=165 165w,
              ${banner.image_mobile}&amp;width=220 220w,
              ${banner.image_mobile}&amp;width=360 360w,
              ${banner.image_mobile}&amp;width=420 420w"
              width="420" height="420"
              class="motion-reduce media_product medium-hide large-up-hide"
              sizes="(max-width: 1024px) 220px, (min-width: 1024px) 360px, (min-width:1400px) 420px"
            >
          ${typeof banner.link === 'object' && banner.link !== null && 'url' in banner.link && typeof banner.link.url === 'string' && banner.link.url.trim() !== '' ? `</a>` : '' }
        </li>
      `;
    } else if (banner.type === 'feedback-section') {
      return `
        <li data-appended="addedDOMNode"
            data-full-width="fullWidth"
            data-id="${banner.id}"
            class="grid__item scroll-trigger full-width-banner"
        >
          <skeleton style="--skeleton-width: 100%; --skeleton-height: 300px; --skeleton-radius: 16px; --skeleton-bg: rgba(124, 128, 52,0.2); --skeleton-shine-color: rgba(124, 128, 52, 0.3); --skeleton-animation-duration: 1.7s;"></skeleton>
        </li>
      `;
    }
    return null;
  }

  function getBannerDOMNodeToAppend(banner) {
    let DOMStringToAppend = getHTMLStringToAppend(banner);
    let templateContainer = document.createElement('template'); // template is better than div for appending performance
    templateContainer.innerHTML = DOMStringToAppend.trim(); // remove whitespaces
    return templateContainer.content.firstElementChild; // get the first element inside the template [i.e - div to bannerToAppend]
  }

  function isMobile() {
    return window.innerWidth <= 768;
  }

  let productCards = document.querySelectorAll('#product-grid .grid__item');
  let productCardsContainer = document.querySelector('#product-grid');
  let productGridMobileColoumns = viewportType === 'mobile' && gridSize ? gridSize : productCardsContainer.dataset.mobileColumns;
  let productGridDesktopColumns = viewportType === 'desktop' && gridSize ? gridSize : productCardsContainer.dataset.desktopColumns;
  // Clear Product Grid Container of All the Appended Elements
  productCardsContainer.querySelectorAll('[data-appended]').forEach(el => {
    el.remove();
  })

  // Get Fresh Copy of Product Cards from DOM
  productCards = document.querySelectorAll('#product-grid .grid__item');

  // Keep a count of Appended Cards
  // This is used to determine the position of the banners after some cards are appended
  let cardsAppendedCount = 0;
  let productGridColoumns = !isMobile() ? productGridDesktopColumns : productGridMobileColoumns;

  // Sort Array for the correct positioning of the banners
  PRODUCT_CARDS_BANNER_OBJECTS.sort((a, b) => a.position - b.position);


  let extendedArray = Array(MIN_PRODUCT).fill(null).concat(Array.from(productCards));

  // Append Product Card Banners 1st as they will Shift the Cards Position
  // Causing the Full Width Banners to Shift as well
  PRODUCT_CARDS_BANNER_OBJECTS.forEach((banner, index) => {
    let bannerToAppend = getBannerDOMNodeToAppend(banner);
    if(IS_DEFAULT_PAGINATION) {
      if (bannerToAppend && banner.type === 'product-card-banner' && banner.position >= MIN_PRODUCT && banner.position <= MAX_PRODUCT) {
        let bannerPosition = banner.position - 1 - cardsAppendedCount;
        // REPLACE the product card at bannerPosition with the banner
        if (extendedArray[bannerPosition]) {
          extendedArray[bannerPosition].replaceWith(bannerToAppend);
        }
        cardsAppendedCount++; // increment the count of appended cards
      }
    } else {
      if (bannerToAppend && banner.type === 'product-card-banner' && banner.position <= productCards.length) {
        let bannerPosition = banner.position - 1 - cardsAppendedCount;
        // REPLACE the product card at bannerPosition with the banner
        if (productCards[bannerPosition]) {
          productCards[bannerPosition].replaceWith(bannerToAppend);
        }
        cardsAppendedCount++; // increment the count of appended cards
      }
    }
  });

  // Get Fresh Copy of Product Cards from DOM
  productCards = document.querySelectorAll('#product-grid .grid__item');

  // Sort Array for the correct positioning of the banners
  FULL_WIDTH_BANNER_OBJECTS.sort((a, b) => a.full_width_banner_row - b.full_width_banner_row);

  const templateDiv = document.createElement('div');
  templateDiv.classList.add('placeholder');
  extendedArray = Array(MIN_PRODUCT).fill(templateDiv).concat(Array.from(productCards));

  // Append Full Width Banners
  FULL_WIDTH_BANNER_OBJECTS.forEach((banner, index) => {
    let bannerToAppend = getBannerDOMNodeToAppend(banner);
    let bannerRow = banner.full_width_banner_row;
    let noOfRows = Math.floor(extendedArray.length / productGridColoumns);

    if(IS_DEFAULT_PAGINATION) {
      const MIN_ROW = productGridColoumns * (CURRENTPAGE - 1);
      const MAX_ROW = productGridColoumns * CURRENTPAGE;

      let bannerInsertionPosition = (bannerRow - index) * productGridColoumns - 1;
      bannerInsertionPosition = bannerInsertionPosition <= MIN_PRODUCT ? bannerInsertionPosition + 1 : bannerInsertionPosition;

      if (bannerToAppend && (banner.type === 'full-width-banner' || banner.type === 'feedback-section') && bannerRow > MIN_ROW && bannerRow <= MAX_ROW) {
        if (bannerInsertionPosition <= MIN_PRODUCT) {
          extendedArray[bannerInsertionPosition].before(bannerToAppend);
        } else {
          extendedArray[bannerInsertionPosition].after(bannerToAppend);
        }
      }
    } else {
      let bannerInsertionPosition = (banner.full_width_banner_row - index) * productGridColoumns - 1;
      if (bannerToAppend && (banner.type === 'full-width-banner' || banner.type === 'feedback-section') && bannerRow <= noOfRows) {
        productCards[bannerInsertionPosition].after(bannerToAppend);
      }
    }
  });
}
appendBannersInsideProductGrid();

// Listen for Grid View Change Event
// When Grid View Changes, Re-Append the Banners
// This is done to ensure that the Banners are appended in the correct position
document.addEventListener('grid-view-change', (event) => {
  let { gridSize, viewportType } = event.detail;
  appendBannersInsideProductGrid(gridSize, viewportType);
});
